import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CTASection() {
  const { ref, style } = useScrollReveal({
    threshold: 0.1,
    distance: 32,
    duration: 800,
  });
  const { ref: refBtn, style: styleBtn } = useScrollReveal({
    threshold: 0.1,
    distance: 24,
    duration: 700,
    delay: 200,
  });

  return (
    <section className="w-full bg-white py-20 md:py-28 px-6 lg:px-[7%]">
      <div className="relative rounded-3xl overflow-hidden bg-brand-black">
        <div className="absolute inset-0">
          <img
            src="https://readdy.ai/api/search-image?query=elegant-luxury-closet-wardrobe-organized-minimal-space-warm-lighting-soft-grain-texture-editorial-photography-barcelona-atelier-high-end-fashion-interior-cream-tones&width=1400&height=600&seq=203&orientation=landscape"
            alt="Armario organizado"
            className="w-full h-full object-cover object-top opacity-30"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-brand-black via-brand-black/80 to-transparent" />
        </div>
        <div
          ref={ref}
          style={style}
          className="relative z-10 py-16 md:py-24 px-8 md:px-16 max-w-2xl"
        >
          <h2 className="font-serif text-white text-[clamp(1.6rem,3.5vw,2.4rem)] leading-[1.3]">
            Tu imagen es una inversión, no un gasto
          </h2>
          <p className="font-sans text-white/70 text-base leading-relaxed mt-5">
            Las primeras impresiones se forman en menos de siete segundos.
            Durante ese tiempo, tu imagen ya ha dicho más que tus palabras.
            Anthony Sánchez te ayuda a controlar ese mensaje.
          </p>
          <div ref={refBtn} style={styleBtn} className="mt-8">
            <Link
              to="/contacto"
              className="inline-flex items-center justify-center bg-white text-brand-black font-sans text-[15px] font-medium tracking-wide px-10 py-4 rounded-full hover:bg-brand-sage transition-colors duration-300 whitespace-nowrap"
            >
              Solicitar entrevista exclusiva
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}